import { connect } from 'react-redux';
import { IStoreState } from 'src/entity/StateEntity';
import PriceChangeDetailPage from 'src/components/views/Price/PriceChangeDetailListPage';

const mapStateToProps = ({ userState: { userInfo } }: IStoreState) => ({
  userInfo,
});

export default connect(mapStateToProps)(PriceChangeDetailPage);



// WEBPACK FOOTER //
// ./src/containers/PriceChangeDetail.ts